<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="24">
        <a-card :title="$t('cardTitle.transactions')" class="style3">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('label.invoiceID') }}</th>
                <th>{{ $t('label.total') }}</th>
                <th>{{ $t('label.state') }}</th>
                <th>{{ $t('label.date') }}</th>
                <th>{{ $t('label.description') }}</th>
                <th>{{ $t('label.invoice') }}</th>
                <th>{{ $t('label.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t in transactions" :key="t.invoice_number">
                <td>{{ t.invoice_number }}</td>
                <td>{{ t.currency }} {{ Number(t.total_in_cents / 100).toFixed(2) }}</td>
                <td style="text-transform: capitalize">{{ t.state }}</td>
                <td>{{ t.due_on | formatDate }}</td>
                <td>{{ t.description }}</td>
                <td>
                  <span class="glyphicon glyphicon-download" aria-hidden="true"></span>
                  <a href="javascript: void(0);" @click="doGetInvoicePdf(t.invoice_number)">{{ $t('label.download') }}</a>
                </td>
                <td>
                  <a v-if="t.state !== 'paid'" @click="doPayAndSubscribe">Pay now</a>
                </td>
              </tr>
            </tbody>
          </table>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="24">
        <a-card title="Subscription Management" class="style3">
          <p>To change or cancel your account please schedule a time to speak with your TrueLife.org evangelism representative.</p>
          <p class="text"><a class="link-button" href="https://meetings.hubspot.com/rich-land" target="_blank">Click Here</a></p>
        </a-card>
      </a-col>
    </a-row>
    <template v-if="getPlan">
      <a-modal v-model="showResubscribeModal" :title="`Your subscription is ${getPlan.status}`" on-ok="doResubscribe">
        <template slot="footer">
          <a-button
            key="back"
            @click="
              e => {
                showResubscribeModal = false;
              }
            "
          >
            Cancel
          </a-button>
          <a-button key="submit" type="primary" :loading="isLoading" @click="doResubscribe"> Resubscribe </a-button>
        </template>
        <div class="text-center">
          <p>
            Your current subscription is {{ getPlan.status }} and all servie is blocked for you,<br />
            please resubscribe to use Truelife.org.
          </p>
          <p>
            Membership Type: <strong>{{ getPlan.title }}</strong>
          </p>
          <p>
            Subscription: <strong>{{ getPlan.subscription }}</strong>
          </p>
        </div>
      </a-modal>
    </template>
  </div>
</template>
<script>
import PaymentService from '@/services/PaymentService';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { mapState } from 'vuex';
export default {
  data: () => ({
    transactions: [],
    subscriptions: [],
    plans: [],
    showResubscribeModal: false,
    isLoading: false,
  }),
  computed: {
    ...mapState(['settings', 'user']),
    getNextPayment() {
      return !isEmpty(this.transactions) && moment(this.transactions[0].due_on).add('years', 1);
    },
    getPlan() {
      if (!isEmpty(this.plans)) {
        const membership = this.user.user.membership;
        const plan = this.plans.find(p => p.plan_code === membership.plan_code);

        if (!plan) {
          return;
        }

        return {
          title: `${Number(plan.min_attendance).toLocaleString()} - ${Number(plan.max_attendance).toLocaleString()} (Attendance)`,
          subscription: `$${plan.price}/${plan.plan_type === 'yearly' ? 'Y' : 'MO'}`,
          status: membership.state,
          remainingCards: membership.active_cards,
        };
      }
      return null;
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async created() {
    const resp = await PaymentService.getTransactions();
    this.transactions = resp;

    const plans = await PaymentService.getPlans();
    this.plans = plans;
  },
  methods: {
    formatDate(date) {
      return moment(date).add('years', 1).format('MM/DD/YYYY');
    },
    async doGetInvoicePdf(invoiceNumber) {
      try {
        const resp = await PaymentService.getInvoicePdf(invoiceNumber);
        import('@/utils/fileSaver').then(file => {
          file.savePdf(resp, invoiceNumber);
        });
      } catch (error) {
        console.error({ error });
      }
    },
    async doResubscribe() {
      try {
        await PaymentService.subscribe(this.user.user.membership.plan_code);
      } catch (error) {
        console.error({ error });
      }
    },
    async doPayAndSubscribe() {
      try {
        await PaymentService.payInvoiceAndSubscribe(this.user.user.membership.plan_code);
      } catch (error) {
        console.error({ error });
      }
    },
  },
};
</script>
<style lang="scss">
.plan-status {
  text-transform: capitalize;
}
.plan-active {
  color: #33cacc;
}
.plan-canceled,
.plan-paused,
.plan-expired,
.plan-past_due {
  color: #eb685f;
}
</style>
